(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.innerWidth < 1000) return;

  var FACTOR = 0.25;

  /* Photographic bands drift against the scroll so they read as slower than
     the page. The CSS over-sizes the image by 60px at the top and bottom (see
     .commercial-banner__bg--parallax); travelling the full 60 would leave the
     edge flush, so cap it lower and keep the remainder as slack against
     sub-pixel rounding. */
  var PARALLAX_SHIFT = 50;

  var sections = [];
  var media = [];
  var ticking = false;

  function setup() {
    var heroText = document.querySelector('.rocker-chair-hero .content-over-media .content');
    if (heroText) {
      var container = heroText.closest('.content-over-media');
      sections.push({ container: container || heroText.parentElement, text: heroText });
    }

    var resortText = document.querySelector('.wfr-resorts-overlay__content');
    if (resortText) {
      sections.push({ container: document.querySelector('.wfr-resorts-overlay'), text: resortText });
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('.commercial-banner__bg--parallax'),
      function (image) {
        var banner = image.closest('.commercial-banner');
        if (banner) media.push({ container: banner, image: image });
      }
    );

    if (sections.length === 0 && media.length === 0) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function update() {
    ticking = false;
    var viewH = window.innerHeight;

    sections.forEach(function (item) {
      var rect = item.container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewH) return;

      var center = rect.top + rect.height / 2;
      var offset = ((center - viewH / 2) * FACTOR).toFixed(1);
      item.text.style.transform = 'translateY(' + offset + 'px)';
    });

    media.forEach(function (item) {
      var rect = item.container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewH) return;

      /* -1 when the band is about to enter from the bottom, 0 when it is
         centred, +1 once it has cleared the top. */
      var center = rect.top + rect.height / 2;
      var progress = (viewH / 2 - center) / ((viewH + rect.height) / 2);
      progress = Math.max(-1, Math.min(1, progress));

      item.image.style.transform =
        'translate3d(0, ' + (progress * PARALLAX_SHIFT).toFixed(1) + 'px, 0)';
    });
  }

  if (document.readyState !== 'loading') {
    setup();
  } else {
    document.addEventListener('DOMContentLoaded', setup);
  }
})();
